import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const ExpandableNotesContainer = ({ children, id, state, ...rest }) => {
  return (
    <Container id={id} state={state} {...rest}>
      {children}
    </Container>
  );
};

const heightMap = {
  minimized: '200px',
  maximized: '80vh',
  default: '50vh',
};

const Container = styled.div<{ id?: string; state?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: ${(props) => heightMap[props.state || 'default']};
  margin-bottom: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid ${colorPalette.neutral550};
  background-color: ${(props) => (props.id === 'Ride' ? colorTokens.note.ride : colorTokens.background.default)};
  overflow: ${(props) => (props.state === 'maximized' ? 'auto' : 'hidden')};
  position: relative;
  transition: all 0.1s ease;
`;
